/**
 * Devuelve el numero de decimales de un numero. Entre 0 y x.
 * Ojo que el maximo son 16 decimales
 *
 * @param {number} num: el float del cual vamos a contar los decimales
 *
 * @return {int} el numero de decimal
 *
 * @throw `countDecimals: is not a number`
 */

import { isNumber } from '../number/isNumber';

export function countDecimals(num) {
  if (!isNumber(num)) {
    throw new Error('countDecimals: is not a number');
  }
  const s = num.toString();
  if (!s.includes('.')) {
    return 0;
  }
  const pos = s.indexOf('.');
  return s.length - pos - 1;
}
